import React, { useState } from "react";
import { EMPLOYERS } from "@/data/testimonials";

function EmployerLogo({ emp }) {
  // Self-hosted logo first (100% reliable). If missing or fails to load, use branded colored badge.
  const [errored, setErrored] = useState(false);

  if (!emp.logo || errored) {
    return (
      <span className="marquee-badge" style={{ backgroundColor: emp.color }}>
        {emp.name}
      </span>
    );
  }
  return (
    <img
      src={emp.logo}
      alt={emp.name}
      title={emp.name}
      onError={() => setErrored(true)}
      loading="lazy"
    />
  );
}

export function HiredAt({ te }) {
  return (
    <section className="py-8 lg:py-16 border-y border-[#EAE5DB] bg-white" data-testid="hired-at-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 lg:mb-10">
          <div className="overline mb-2">{te.hired_at.sub}</div>
          <h3 className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-[#292524]">
            {te.hired_at.title}
          </h3>
        </div>
        <div className="marquee-wrap">
          <div className="marquee-track">
            {/* Double the list for seamless infinite scroll */}
            {[...EMPLOYERS, ...EMPLOYERS].map((emp, i) => (
              <div key={`${emp.name}-${i}`} className="marquee-logo" data-testid={`employer-${emp.name.replace(/\s+/g, "-")}`}>
                <EmployerLogo emp={emp} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
